import { render, staticRenderFns } from "./Betfair.vue?vue&type=template&id=4a8143c8&scoped=true&"
import script from "./Betfair.vue?vue&type=script&lang=js&"
export * from "./Betfair.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Betfair.vue?vue&type=style&index=1&id=4a8143c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8143c8",
  null
  
)

export default component.exports